import PropTypes from 'prop-types';
import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import styles from './FeaturedNow.less';

const FeaturedNow = ({ activePagesCount, intl }) => (
  <div styleName="container">
    <p className="dna-text-xl">
      <span className="dna-text-normal">
        {intl.formatNumber(activePagesCount)}{' '}
      </span>
      <span>people raising funds now</span>
    </p>
  </div>
);

FeaturedNow.propTypes = {
  activePagesCount: PropTypes.number.isRequired,
  intl: intlShape,
};

export default injectIntl(CSSModules(FeaturedNow, styles));



// WEBPACK FOOTER //
// ./src/components/Home/FeaturedNow.js